// Первым: коды из CRM (окно ведущего, страница записи) — прочь из адреса до роутера и запросов.
import '@/shared/crm/launchCode'
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// import * as Sentry from "@sentry/vue";

import dayjs from 'dayjs'
import 'dayjs/locale/ru'
import utc from 'dayjs/plugin/utc'
import relativeTime from 'dayjs/plugin/relativeTime'
import customParseFormat from 'dayjs/plugin/customParseFormat'

dayjs.extend(relativeTime)
dayjs.extend(customParseFormat)
dayjs.extend(utc)
dayjs.locale('ru')

// Возврат из Google OAuth: перехватываем ?google=... ДО инициализации роутера
// (у SPA нет пути /calendar, и «сырой» query ломал бы маршрутизацию). Флаг
// сохраняем и чистим URL — его позже подхватят MessengerView/CalendarView.
try {
  const googleReturn = new URLSearchParams(window.location.search).get('google')
  if (googleReturn) {
    sessionStorage.setItem('rooms_google_return', googleReturn)
    window.history.replaceState({}, '', '/')
  }
} catch (e) {
  // sessionStorage/URL могут быть недоступны — не критично
}

const app = createApp(App)
app.use(store)
app.use(router)

window['router'] = router

// Раньше глобального обработчика не было: любая ошибка рендера роняла всё в белый
// экран без следов. Теперь ловим её, логируем и показываем фолбэк с кнопкой
// «Обновить» вместо пустого белого экрана (и не перекрываем уже отрисованный UI).
function showFatalFallback(): void {
  try {
    const root = document.getElementById('app')
    if (root && root.childElementCount > 0) return
    if (document.getElementById('rooms-fatal-fallback')) return
    const box = document.createElement('div')
    box.id = 'rooms-fatal-fallback'
    box.style.cssText = 'position:fixed;inset:0;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:14px;padding:24px;font-family:Arial,Helvetica,sans-serif;text-align:center;background:#fff;color:#16181d;z-index:99999'
    box.innerHTML = '<div style="font-size:18px;font-weight:700">Не удалось загрузить</div>'
      + '<div style="font-size:14px;color:#6b7280;max-width:360px;line-height:1.4">Обновите страницу. Если не помогло — очистите данные сайта в браузере и войдите снова.</div>'
    const btn = document.createElement('button')
    btn.textContent = 'Обновить'
    btn.style.cssText = 'border:none;border-radius:10px;padding:12px 24px;background:#4274d4;color:#fff;font-size:15px;font-weight:600;cursor:pointer'
    btn.onclick = () => location.reload()
    box.appendChild(btn)
    document.body.appendChild(box)
  } catch (e) { /* ignore */ }
}

app.config.errorHandler = (err, _instance, info) => {
  console.error('[app errorHandler]', info, err)
  showFatalFallback()
}
window.addEventListener('unhandledrejection', (e) => console.error('[unhandledrejection]', e.reason))
window.addEventListener('error', (e) => console.error('[window error]', (e as ErrorEvent).error || (e as ErrorEvent).message))
// Страховка: если через 4с #app пуст — рендер провалился, показываем фолбэк.
setTimeout(() => { const r = document.getElementById('app'); if (r && r.childElementCount === 0) showFatalFallback() }, 4000)

app.directive('focus', {
  mounted(el) {
    el.focus()
  },
})

// Sentry.init({
//   dsn: "https://88c00e113815f4bedc640f795828d8fd@sentry.dtdesk.ru/4",
//   integrations: [
//     Sentry.browserTracingIntegration({ router }),
//     Sentry.replayIntegration({
//       maskAllText: false,
//       blockAllMedia: false,
//     }),
//   ],
//   app: app,
//   environment: "development",
//   attachProps: true,
//   logErrors: true,
//   trackComponents: true,
//   // Performance Monitoring
//   tracesSampleRate: 1.0, //  Capture 100% of the transactions
//   // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
//   tracePropagationTargets: [
//     "localhost",
//     /^https:\/\/dtchat.dtdesk.ru\/api/,
//     /^wss:\/\/dtchat.dtdesk.ru\/ws/,
//     /^https:\/\/dtchatm.d-tech.site\/api/,
//     /^wss:\/\/dtchatm.d-tech.site\/ws/,
//   ], //, /^https:\/\/yourserver\.io\/api/],
//   // Session Replay
//   replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
//   replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
// });

app.mount('#app')